import React, { useEffect } from 'react';
import { getStoredRole, isAdminPath, isUserOnlyPath, useSetState } from 'utils/functions.utils';
import { useSelector } from 'react-redux';
import { reducers } from 'interfaces/common.interface';
import connectSocket from 'utils/socket.utils';
import { Models, NavBar } from 'utils/imports.utils';
import { preloadFonts } from 'utils/preload_fonts';
import { useLocation, useNavigate } from 'react-router-dom';

let socket: any;

export default function Main(props: any) {
  const [state, setState] = useSetState({ signout: false, loading: false , profileData: null});
  const user = useSelector((store: reducers) => store.user);
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    // socket = connectSocket();
    preloadFonts().then(() => {
      console.log("All fonts preloaded");
    });
  }, []);

  // const showSuccess = (text: string) => {
  //   //show snack success
  // };

  // const throwError = (text: string) => {
  //   //show snack error
  // };

  // const getUser = async () => {
  //   try {
  //     const res: any = await Models.auth.getUser();
  //     if (res && res.data) {
  //       console.log("login success");
  //     } else {
  //       throw new Error("Invalid response");
  //     }
  //   } catch (error: any) {
  //     const errorMessage = error?.response?.data?.message || error.message;
  //     console.error("Error fetching user:", errorMessage);
  
  //     if (
  //       errorMessage === "User doesn't exist" ||
  //       errorMessage === "Failed to fetch user"
  //     ) {
  //       localStorage.removeItem('token');
  //       window.location.href = '/login';
  //     }
  //   }
  // };
  const getProfileData = async () => {
    try {
        const response: any = await Models.auth.getUser();
        if(response){
          setState({ profileData: response.data });
        }
        
        
    } catch (err) {
        console.log('Failed to fetch profile Data', err);
    }
};
  

  const PUBLIC_PATHS = ['/login', '/signup', '/forgot-password', '/enter-otp', '/reset-password', '/reset-password-successful'];

  useEffect(() => {
    const token = localStorage.getItem('token');
    const currentPath = location.pathname;

    if (!token && !PUBLIC_PATHS.includes(currentPath)) {
      navigate('/login');
    }
    if (token && (currentPath === '/login' || currentPath === '/signup')) {
      navigate('/welcome');
    }
    if (token) {
      getProfileData();
  }
  }, [navigate, location.pathname]);

  // Admin screens are for admins only. The role is the one stored at login, refreshed by the profile
  // fetched above; until either is known we hold back rendering rather than flash the admin shell.
  const role: string | undefined = state.profileData?.role ?? getStoredRole();
  const hasToken = !!localStorage.getItem('token');
  const onAdminPath = hasToken && isAdminPath(location.pathname);
  const isForbidden = onAdminPath && role !== undefined && role !== 'admin';
  const onUserOnlyPath = hasToken && isUserOnlyPath(location.pathname);
  const isAdminOnUserScreen = onUserOnlyPath && role === 'admin';
  const isRolePending = onAdminPath && role === undefined;

  useEffect(() => {
    if (isForbidden) navigate('/welcome', { replace: true });
    if (isAdminOnUserScreen) navigate('/admin', { replace: true });
  }, [isForbidden, isAdminOnUserScreen, navigate]);

  const setMainLoading = (loading: boolean) => {
    setState({ loading: loading });
  };

  const renderChildren = () => {
    return React.Children.map(props.children, (child: any) => {
      if (child && typeof child.type === 'function') {
        return React.cloneElement(child, {
          user,
          // showSuccess,
          // throwError,
          socket,
          setMainLoading,
        });
      }
      return child;
    });
  };

  if (isForbidden || isAdminOnUserScreen || isRolePending) return null;
  if (state.signout) window.location.href = '/';
  if (state.loading) return <div>Loading</div>;
  return (
    <div className={props.className}>
      <div
        style={{
          display: 'flex',
          minHeight: '100vh',
          flexDirection: 'column',
          position: 'relative',
          backgroundColor: props.backgroundColor || '#fff',
        }}>
          <NavBar
            logoSize={{width: props.logoSize?.width, height: props.logoSize?.height}}
            isRenderOnlyLogo={props.isRenderOnlyLogo}
            isEditor={props.isEditor}
            breadcrumbs={props.breadcrumbs}
            profileData={state.profileData}
          />
          <div
            className="main_body"
            style={
              props.isAdmin ?
              {}
              :
              {
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              }
            }>
              {renderChildren()}
          </div>
      </div>
    </div>
  );
}
